import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, ActionIconProps } from '@mantine/core';

type AddActionIconPropsType = {
  onClick?: () => void;
  ref?: React.RefObject<HTMLButtonElement>;
  ariaLabel?: string;
} & ActionIconProps;

export const AddActionIcon: React.FC<AddActionIconPropsType> = ({
  onClick,
  ref,
  ariaLabel,
  ...props
}) => {
  return (
    <ActionIcon
      color="blue"
      variant="outline"
      onClick={onClick ?? undefined}
      data-testid="add-action-icon"
      ref={ref}
      aria-label={ariaLabel}
      {...props}
    >
      <FontAwesomeIcon icon={faPlus} />
    </ActionIcon>
  );
};
